define( function() {
	return ( /^(?:checkbox|radio)$/i );
} );



/*****************
 ** WEBPACK FOOTER
 ** F:/actions-runner/_work/scpbuildinig_sentience.portal.devops/scpbuildinig_sentience.portal.devops/src/Production/Portal/Cloud.Platform.Global.Portal.DevOps.Web/~/jquery/src/manipulation/var/rcheckableType.js
 ** module id = 855
 ** module chunks = 2
 **/